import { Card } from '@digdir/designsystemet-react';

import styled from '../../../../../styled';

const Actions = styled.div`
  display: flex;
  gap: var(--ds-size-4);
`;

const ContentCard = styled(Card)`
  border-radius: var(--ds-border-radius-md);
`;

const TiltakSectionCard = styled(Card)`
  border-radius: var(--ds-border-radius-md);
  gap: var(--ds-size-8);
  display: flex;
  flex-direction: column;
`;

const TiltakList = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-2);
`;

const StyledTiltakItemCard = styled(Card)`
  border-radius: var(--ds-border-radius-md);
  background-color: var(--ds-color-background-tinted);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--ds-size-4);
`;

export { TiltakSectionCard, TiltakList, Actions, StyledTiltakItemCard, ContentCard };
